import React from 'react';

const CONDITION_OPTIONS = [
  { id: 'LESS_THAN_ACCEPTANCE', label: 'Less than X% participants accepted' },
  { id: 'NOT_RESPONDED', label: 'Participant has not responded' },
  { id: 'POLL_COMPLETED', label: 'Poll is completed' },
  { id: 'ALL_ACCEPTED', label: 'All participants accepted' },
  { id: 'EVENT_STARTED', label: 'Event has started' },
];

const ACTION_OPTIONS = [
  { id: 'CANCEL_EVENT', label: 'Cancel event' },
  { id: 'SEND_REMINDER', label: 'Send reminder' },
  { id: 'SELECT_WINNER', label: 'Select winning option' },
  { id: 'CREATE_EVENT', label: 'Create another event' },
  { id: 'CREATE_SPLITWISE', label: 'Create Splitwise event' },
  { id: 'SEND_NOTIFICATION', label: 'Send notification' },
];

const RuleBuilder = ({ rules = [], onChange }) => {
  const updateRule = (index, patch) => {
    const next = rules.map((r, i) => (i === index ? { ...r, ...patch } : r));
    onChange(next);
  };

  const addRule = () => {
    onChange([
      ...rules,
      { id: `rule-${Date.now()}`, condition: 'NOT_RESPONDED', action: 'SEND_REMINDER', params: {} },
    ]);
  };

  const removeRule = (index) => {
    onChange(rules.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold text-gray-900 dark:text-white">Automation rules</h4>
        <button
          type="button"
          onClick={addRule}
          className="text-xs font-semibold text-primary-600 hover:text-primary-700 dark:text-primary-400"
        >
          + Add rule
        </button>
      </div>

      {rules.length === 0 && (
        <p className="text-xs text-gray-500 dark:text-gray-400 rounded-lg border border-dashed border-gray-300 dark:border-gray-600 px-3 py-4 text-center">
          No rules yet. Add IF → THEN automations for reminders, cancellations, and follow-ups.
        </p>
      )}

      {rules.map((rule, index) => (
        <div key={rule.id || index} className="rounded-lg border border-gray-200 dark:border-gray-700 p-3 space-y-2 bg-white dark:bg-gray-800/50">
          <div className="flex items-center gap-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
            <span className="text-primary-600">IF</span>
            <select
              value={rule.condition}
              onChange={(e) => updateRule(index, { condition: e.target.value })}
              className="flex-1 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs font-normal normal-case px-2 py-1.5"
            >
              {CONDITION_OPTIONS.map((opt) => (
                <option key={opt.id} value={opt.id}>{opt.label}</option>
              ))}
            </select>
          </div>
          <div className="flex items-center gap-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
            <span className="text-emerald-600">THEN</span>
            <select
              value={rule.action}
              onChange={(e) => updateRule(index, { action: e.target.value })}
              className="flex-1 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs font-normal normal-case px-2 py-1.5"
            >
              {ACTION_OPTIONS.map((opt) => (
                <option key={opt.id} value={opt.id}>{opt.label}</option>
              ))}
            </select>
            <button
              type="button"
              onClick={() => removeRule(index)}
              className="text-gray-400 hover:text-red-500 p-1"
              aria-label="Remove rule"
            >
              ✕
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RuleBuilder;
